import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function DemolitionServices() {
  const features = ["Sichere Demontage", "Umweltgerechte Entsorgung", "Fachgerechte Planung", "Schnelle Abwicklung"];
  return;
}